import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";
import { validateImportedEvent, publishImportedEvent, ImageImportError } from "./importedEventService";

// Fila `pendingEvents` (eventos encontrados pelo scraper). As regras do
// Firestore não liberam essa coleção para o cliente: tudo passa por
// callables que checam role admin no servidor (functions/pendingEventsAdmin.js).

const listCallable = httpsCallable(functions, "listPendingEvents");
const updateCallable = httpsCallable(functions, "updatePendingEvent");
const discardCallable = httpsCallable(functions, "discardPendingEvents");
const markApprovedCallable = httpsCallable(functions, "markPendingApproved");
// A busca pode levar vários minutos (timeout da function: 30 min). O padrão
// do SDK (70s) cortaria a chamada no meio.
const runScraperCallable = httpsCallable(functions, "runScraperNow", { timeout: 31 * 60 * 1000 });
const scraperStatusCallable = httpsCallable(functions, "runScraperNow");

// Dispara a busca em todas as fontes. → { status: 'done', summary }
// | { status: 'busy', message, running }
export const runScraperNow = async () => (await runScraperCallable({})).data;

// → { running: {trigger, startedAt} | null, lastRun: {finishedAt, summary} | null }
export const getScraperStatus = async () => (await scraperStatusCallable({ statusOnly: true })).data;

export const listPendingEvents = async () => {
  const result = await listCallable({});
  return result.data.items || [];
};

export const countPendingEvents = async () => {
  const result = await listCallable({ countOnly: true });
  return result.data.count || 0;
};

export const updatePendingEvent = (id, event) => updateCallable({ id, event });

export const discardPendingEvents = (ids) => discardCallable({ ids });

// Motivo que impede a aprovação, ou null. Checado antes de publicar para não
// gerar evento sem preço/imagem no app.
export const approvalBlocker = (event) => {
  if (!event.isFree && (event.ticketPrice === null || event.ticketPrice === undefined || Number(event.ticketPrice) <= 0)) {
    return "Defina o preço (ou marque como gratuito) antes de aprovar";
  }
  if (!event.imageUrl) return "Sem imagem — edite e informe a URL da imagem oficial";
  if (!event.location) return "Sem endereço — edite antes de aprovar";
  return null;
};

// Aprovar = publicar em `events` pelo MESMO fluxo do importador JSON
// (validação, datas, geocode, re-upload da imagem para o Storage) e marcar
// o pendente como aprovado.
export const approvePendingEvent = async (pending) => {
  const blocker = approvalBlocker(pending.event);
  if (blocker) throw new Error(blocker);

  validateImportedEvent(pending.event);
  // sourceUrl = página de origem do evento, gravada no evento publicado
  // para rastreio (a imagem original vai em imageSourceUrl).
  const event = { ...pending.event, sourceUrl: pending.sourceUrl || null };
  let eventId;
  try {
    eventId = await publishImportedEvent(event);
  } catch (error) {
    // Imagem principal falhou no download/upload (ex.: original > 5MB):
    // tenta a reserva guardada pelo scraper, se houver.
    if (!(error instanceof ImageImportError) || !pending.altImageUrl) throw error;
    eventId = await publishImportedEvent({ ...event, imageUrl: pending.altImageUrl });
  }
  await markApprovedCallable({ id: pending.id, eventId });
  return eventId;
};
